module.exports = __webpack_public_path__ + "img/IntelliJ_IDEA_icon.6232229e.png";